import { apiService } from './api';

export interface NotificationDTO {
  id: number;
  type: string;
  title: string;
  message: string;
  dataJson?: string;
  linkUrl?: string;
  severity: 'Info' | 'Warning' | 'Critical';
  isRead: boolean;
  createdAt: string;
}

export interface NotificationPage {
  data: NotificationDTO[];
  pagination: { total: number; page: number; pageSize: number };
}

const NOTIFICATIONS_API = '/notifications';

export const notificationService = {
  getMyNotifications: (pageNumber = 1, pageSize = 20, unreadOnly = false) =>
    apiService.get<NotificationPage>(NOTIFICATIONS_API, { pageNumber, pageSize, unreadOnly }),

  getUnreadCount: () =>
    apiService.get<{ count: number }>(`${NOTIFICATIONS_API}/unread-count`),

  markAsRead: (id: number) =>
    apiService.put<boolean>(`${NOTIFICATIONS_API}/${id}/read`, {}),

  markAllAsRead: () =>
    apiService.put<number>(`${NOTIFICATIONS_API}/read-all`, {}),
};

/**
 * Localized rendering: notifications carry a semantic type plus JSON params.
 * If a template exists for the type we render it in the user's language,
 * otherwise we fall back to the English title/message stored on the row.
 */
export const renderNotificationText = (
  n: NotificationDTO,
  t: (key: string, options?: Record<string, unknown>) => string
): { title: string; message: string } => {
  let params: Record<string, unknown> = {};
  try {
    params = n.dataJson ? JSON.parse(n.dataJson) : {};
  } catch {
    // fall back to server text on malformed params
  }

  if (typeof params.docType === 'string') {
    params.docType = t(`notifications.docTypes.${params.docType}`, { defaultValue: params.docType });
  }

  return {
    title: t(`notifications.types.${n.type}.title`, { defaultValue: n.title, ...params }),
    message: t(`notifications.types.${n.type}.message`, { defaultValue: n.message, ...params }),
  };
};
